<script setup lang="ts">
	// import MainFooter from './components/MainFooter.vue'
	import ThemeSwitcher from './components/ThemeSwitcher.vue'
	import LanguageSwitcher from './components/LanguageSwitcher.vue'
	import NavbarMenu from './components/NavbarMenu.vue'
	import UserProfile from './components/HeaderUserProfile.vue'
	// import SearchModul from './components/SearchModul.vue'
	// import SideDrawer from './components/SideDrawer.vue'
	// import Notifications from './components/Notifications.vue'
	import { List } from 'lucide-vue-next'
	import { useBaseStore } from '@/stores/base.store'

	const baseStore = useBaseStore()
	// import Navigation from '@/components/layout/Navigation.vue'
	// import MegaNav from '@/components/layout/MegaNav.vue'
	import DynamicSidePanel from './components/DynamicSidePanel.vue'
	import DynamicHeader from './components/DynamicHeader.vue'
	import FilesUploadDropdown from '@/features/files/FilesUploadDropdown.vue'
	import VersionUpdateIndicator from './components/VersionUpdateIndicator.vue'
	import { currentVersion } from '@/libs/versionChecker'
	import { RouterLink } from 'vue-router'
	// import { watch } from 'vue'

	const handleDrop = async (event: DragEvent) => {
		const files = event.dataTransfer?.files
		console.log({ files })
	}
</script>

<template>
	<div class="" id="layout-main" @dragover.prevent @dragleave.prevent @drop.prevent.st="handleDrop">
		<div class="flex">
			<input
				id="layout-sidebar-toggle-trigger"
				class="hidden"
				aria-label="Toggle layout sidebar"
				type="checkbox" />

			<div id="layout-sidebar" class="">
				<!-- NAV-HEADER -->
				<a class="flex min-h-16 items-center justify-center" href="/" data-discover="true">
					<img alt="logo-dark" class="hidden h-10 dark:inline" src="/img/logo.png" />
					<img alt="logo-light" class="inline h-10 dark:hidden" src="/img/logo.png" />
					<span class="sr-only">Revotec</span>
				</a>

				<!-- NAV-MAIN -->
				<div class="relative mb-4 flex min-h-0 grow">
					<!-- <MegaNav /> -->
					<!-- <NavbarMenu /> -->
					<NavbarMenu />
					<!-- <DynamicSidePanel /> -->

					<!-- <Navigation /> -->
				</div>
				<!-- <div class="p-10"></div> -->

				<!-- NAV-FOOTER -->
				<div class="from-base-300/00 to-base-100 pointer-events-none absolute right-0 bottom-6 left-0 h-20 bg-gradient-to-b">
					<!-- // -->
				</div>

				<!-- VERSION -->
				<RouterLink
					:to="{ name: 'ChangeLogs' }"
					class="bg-base-100 text-base-content/50 hover:text-base-content relative z-20 mt-auto px-4 py-2 text-center text-xs leading-none transition-colors"
					title="Changelogs ansehen">
					v{{ currentVersion }}
				</RouterLink>
				<!-- <div class="flex items
				<!-- <div class="mb-2 p-4"> -->
				<!-- <hr class="border-base-300" /> -->
				<!--
					<div class="flex items-center justify-between gap-4 px-4 py-2">
						<small class="text-xs font-bold uppercase" aria-label="App version">V 0.0.1</small>
						<ThemeSwitcher />
						<LanguageSwitcher />
					</div>
					-->
				<!-- </div> -->
			</div>

			<!--//! TOP-BAR -->
			<div class="flex h-screen min-w-0 grow flex-col overflow-auto">
				<div role="navigation" aria-label="Navbar" id="layout-topbar" class="relative">
					<div class="inline-flex items-center gap-3">
						<label
							class="btn btn-square btn-ghost btn-sm"
							aria-label="Leftmenu toggle"
							for="layout-sidebar-toggle-trigger">
							<List size="20" />
						</label>
						<span v-if="baseStore.isMegalistLoading" class="loading loading-spinner loading-sm opacity-50"></span>
					</div>

					<div class="pointer-events-none absolute left-1/2 -translate-x-1/2">
						<div class="pointer-events-auto">
							<VersionUpdateIndicator />
						</div>
					</div>

					<div class="inline-flex items-center gap-1.5">
						<ThemeSwitcher />
						<FilesUploadDropdown />
						<LanguageSwitcher />
						<!-- <Notifications /> -->
						<!-- <label for="layout-rightbar-drawer" class="btn btn-circle btn-ghost btn-sm drawer-button">
							<Grip size="20" />
						</label> -->
						<UserProfile />
					</div>
				</div>

				<!-- MAIN-CONTENT -->
				<div id="layout-content">
					<!-- <DynamicHeader />
					<div class="flex">
						<DynamicSidePanel />
						<slot name="content" />
						<div class="container mx-auto" v-cloak>
							<slot />
						</div>
					</div> -->

					<!-- <div class="container" v-cloak>
						<div class="grid-layout" :style="gridStyle">
							<div class="col-span-2">
								<DynamicHeader />
							</div>
							<div class="">
								<DynamicSidePanel />
							</div>

							<div class="overflow-hidden">
								<slot />
							</div>
						</div>
					</div> -->

					<div class="h-container container mx-auto" v-cloak>
						<div class="grid-layout">
							<div class="container-header-row">
								<DynamicHeader />
							</div>

							<div class="flex gap-2">
								<div class="flex-1">
									<DynamicSidePanel />
								</div>

								<div class="w-full flex-auto overflow-hidden">
									<slot />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <SideDrawer /> -->
	</div>
</template>

<style scoped>
	@reference "@/styles/tailwind.css";
	.grid-layout {
		/* @apply grid grid-cols-2 gap-1 p-4; */
		@apply grid grid-cols-1 gap-2 p-2;
		@apply transition-all duration-200;
		@apply grid-rows-[auto_1fr];
		@apply overflow-auto;
		@apply h-full;

		/* max-height: calc(100vh - 4rem); */
		/* @apply grid-cols-[280px_auto]; */
		/* grid-template-columns: 280px auto; */
		/* @apply bg-slate-300/40; */
	}
	.container-header-row {
		@apply sticky -top-2 z-100;
	}
</style>
